import React, { useEffect, useRef, useState } from 'react'
import Layout from '../common/Layout'
import ApiHelper from '../../helperFunction/ApiHelper'
import API_ENDPOINTS from '../../helperFunction/Constant'
import { useNavigate } from 'react-router-dom'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { Toast } from 'primereact/toast'
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { InputText } from 'primereact/inputtext'


const Customers = () => {

    const toast = useRef(null)
    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const [customers, setCustomers] = useState([])
    const navigate = useNavigate()

    useEffect(() => {
        getCustomers()
    }, [])

    const getCustomers = () => {
        ApiHelper.get(API_ENDPOINTS.CUSTOMERS).then((res) => {
            console.log('res: ', res);
            if (res.status === 200) {
                setCustomers(res.data.data)
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    const serialNoTemplate = (rowData, options) => { return options.rowIndex + 1; };

    const nameBodyTemplate = (rowData) => {
        return (
            <div style={{ display: "flex", alignItems: "center", gap: "10px", cursor: 'pointer', color: 'blue' }} onClick={() => navigate(`/customers/orders/${rowData.userId}`)}>
                <span>{rowData?.userName}</span>
            </div>

        );
    };

    // const statusBodyTemplate = (rowData) => {
    //     return (
    //         <span className={`badge ${rowData.isActive ? 'bg-success' : 'bg-danger'}`}>
    //             {rowData.isActive ? 'Active' : 'Inactive'}
    //         </span>
    //     );
    // };

    // const actionBodyTemplate = (rowData) => {
    //     return (
    //         <>
    //             <button onClick={() => navigate(`/customers/edit/${rowData.userId}`)} className="btn btn-primary btn-sm me-2"> <i class="bi bi-pencil-square"></i> </button>
    //             {/* <button onClick={() => confirmDeleteDailog(rowData.customerId)} className="btn btn-danger btn-sm"> <i class="bi bi-trash"></i> </button> */}
    //         </>
    //     );
    // };

    // const confirmDeleteDailog = (id) => {
    //     confirmDialog({
    //         message: 'Do you want to delete this record?',
    //         header: 'Delete Confirmation',
    //         icon: 'pi pi-info-circle',
    //         defaultFocus: null,
    //         acceptClassName: 'p-button-danger',
    //         accept: () => deleteCustomer(id),
    //     });
    // };

    // const deleteCustomer = (id) => {
    //     ApiHelper.delete(`${API_ENDPOINTS.CUSTOMERS}/${id}`).then((res) => {
    //         if (res.status === 200) {
    //             toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
    //             getCustomers()
    //         }
    //     }).catch((error) => {
    //         console.log("Error: ", error);
    //     })
    // }

    const renderHeader = () => {
        return (
            <div className="flex justify-content-end">
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={(e) => setGlobalFilterValue(e.target.value)} placeholder="Search" />
                </IconField>
            </div>
        );
    };

    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />
            <Layout>
                <div class="content-wrapper">
                    <div class="container-xxl flex-grow-1 container-p-y">
                        <div class="d-flex justify-content-between align-items-center py-3">
                            <h4 class="fw-bold py-3 mb-2"><span class="text-muted fw-light"><p className="breadcrumb-item active mb-0" aria-current="page">Customers</p></span></h4>
                            {/* <Link class="btn btn-primary" to={'/customers/add'} >Add New Customer</Link> */}
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card mb-4">
                                    <div class="card-body">
                                        <DataTable globalFilter={globalFilterValue} header={renderHeader} paginator rows={50} rowsPerPageOptions={[50, 100, 150, 200]} showGridlines size="small" value={customers} tableStyle={{ minWidth: '50rem' }} >
                                            <Column body={serialNoTemplate} header='S.NO' />
                                            <Column sortable header='Name' body={nameBodyTemplate} field='userName' />
                                            <Column sortable header='Phone' field='userMobileNumber' />
                                            <Column sortable header='Email' field='userEmail' />
                                            <Column sortable header='Signup Date' field='createdAt' body={(rowData) => {
                                                const date = new Date(rowData.createdAt);
                                                return date.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: true, });
                                            }} />
                                            <Column sortable header='Signup outlet/Channel' field='signupSource' />
                                            <Column sortable header='Orders' field='totalOrderCount' />
                                            <Column sortable header='Orders Amount' field='totalOrderAmount' />
                                            {/* <Column sortable header='Status' body={statusBodyTemplate} /> */}
                                            {/* <Column sortable header='Action' body={actionBodyTemplate} /> */}
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default Customers
